module.exports = __webpack_public_path__ + "img/spin_btn.d958564c.png";